import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW6700Model } from '../kymw6700.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 校正紙を取得する
 * @export getProofListService
 * @class GetProofListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetProofListService extends PlessJsonResponderSub<any> {

  vo = {
    outputDiv: '',
    orderCode: '',
    mediumType: '',
    progressWorkNum: '',
    classCode: '',
    buyerCode: '',
    sortItem1: '',
    sortItem2: '',
    sortItem3: '',
    pCodeList: []
  };

  // 処理に使用するModel
  private model: KYMW6700Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetProofListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        ProofList: {
          condition: {
            OutputDiv: this.vo.outputDiv,
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            ProgressWorkNum: this.vo.progressWorkNum,
            ClassCode: this.vo.classCode,
            BuyerCode: this.vo.buyerCode,
            SortItem1: this.vo.sortItem1,
            SortItem2: this.vo.sortItem2,
            SortItem3: this.vo.sortItem3
          },
          combination: this.vo.pCodeList.map(pcode => {
            return {
              condition: {
                PCode: pcode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetProofListService
   */
  execute(model: KYMW6700Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getProofList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetProofListService
   */
  success(data: any): void {
    // レスポンスのファイルパスをマネージに保存
    this.model.updateFileName(data);
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
